import { createNamedActions } from 'utils/namedActionTypesProxy';
import { handleLoanProgramsOptions } from 'utils/programs';

export const LOAN_PROGRAM_OPTIONS_ACTION_TYPE = createNamedActions('loanProgramOptions', {
  SET_LOAN_PROGRAM_OPTIONS: 'SET_LOAN_PROGRAM_OPTIONS',
  RESET_LOAN_PROGRAM_OPTIONS: 'RESET_LOAN_PROGRAM_OPTIONS',
});

export const setLoanProgramOptions = loanProgramOptions => dispatch =>
  dispatch({
    type: LOAN_PROGRAM_OPTIONS_ACTION_TYPE.SET_LOAN_PROGRAM_OPTIONS,
    payload: handleLoanProgramsOptions(loanProgramOptions),
  });
